import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, isRef as _isRef, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }

import { computed, ref, Ref } from 'vue'
import { ElDialog } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { ElMessage } from 'element-plus'
import useFormRules from '@/hooks/useFormRules'
import { ADOType } from '@/types/types'
import { userBindEvse } from '@/api/operation'
import SwitchLocaltionDialog from '@/components/Maps/SwitchLocaltionDialog.vue'
import FormRulesFactory from '@/common/formRules'

import { defineComponent } from 'vue'
import SelectEvse from '@/components/SelectEvse.vue'
const __default__ = defineComponent({
  name: 'UserBindEvse',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  userID: {
    type: String,
    required: true,
  },
  operatorID: {
    type: String,
    required: true,
  },
},
  emits: ["update:modelValue", "submitted"],
  setup(__props, { emit }: { emit: ({
  (e: 'update:modelValue', value: boolean): void
  (e: 'submitted'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const adoFormRule = ref({
  ...FormRulesFactory.generateCustomRules(['adoID'], 'selectNone', 'selectNone'),
})
const { t } = useI18n()





const createRawFormData = () => ({})

const showMapsDialog = ref(false)
const formCom = ref()
const formData: Ref<Record<string, any>> = ref(createRawFormData())
const { createLetterStartRule } = useFormRules()
const rules = {
  name: [...createLetterStartRule()],
}

const isSubmitting = ref(false)
const showDialog = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit('update:modelValue', val)
  },
})

const submit = async () => {
  try {
    console.log('----->log: ', formData)
    await formCom.value.validate()
    isSubmitting.value = true
    await userBindEvse({
      userID: props.userID,
      bindEvse: {
        adoType: ADOType.ADOT_EVSE,
        id: formData.value.adoID,
      },
    })
    ElMessage.success(t(`Base.useSuccess`))
    emit('submitted')
    showDialog.value = false
  } catch (error) {
    //
  } finally {
    isSubmitting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(ElDialog), {
      modelValue: _unref(showDialog),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(showDialog) ? (showDialog).value = $event : null)),
      class: "upsert-dialog",
      title: _unref(t)('Operation.selectEvse'),
      "z-index": 2000
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showDialog.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Base.cancel')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submit,
            disabled: !_ctx.$hasPermission('post'),
            loading: isSubmitting.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Base.confirm')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref_key: "formCom",
          ref: formCom,
          "label-position": "top",
          "require-asterisk-position": "right",
          model: formData.value,
          rules: adoFormRule.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('Evses.equipment'),
                      prop: "adoID",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(SelectEvse, {
                          modelValue: formData.value.adoID,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.adoID) = $event)),
                          operatorID: props.operatorID
                        }, null, 8, ["modelValue", "operatorID"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(SwitchLocaltionDialog, {
      modelValue: showMapsDialog.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showMapsDialog).value = $event))
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})